import { jsx as _jsx } from "react/jsx-runtime";
import useHandleSubmit from "../../../../../../hooks/common/searchers/submit/useHandleSubmit.js";
import useHasErrors from "../../../../../../hooks/common/searchers/useHasErrors.js";
import useValue from "../../../../../../hooks/forms/useValue.js";
import { useSearcherActivitiesProps } from "../../context/index.js";
import * as S from "./styled.js";
const SearcherActivitiesButton = ()=>{
    const props = useSearcherActivitiesProps();
    const { config  } = props ?? {};
    const { literals  } = config ?? {};
    const { submitLabel , search , submit  } = literals ?? {};
    const hasErrors = useHasErrors();
    const handleSubmit = useHandleSubmit();
    const destinationValue = useValue({
        name: 'destination'
    });
    return /*#__PURE__*/ _jsx(S.SearcherButton, {
        onClick: handleSubmit,
        disabled: hasErrors || destinationValue == undefined,
        children: submitLabel ?? search ?? submit
    });
};
export default SearcherActivitiesButton;

//# sourceMappingURL=index.js.map